import axios from 'axios';

import { applications, parserUtils } from 'z-js-commons';

import { API_URL } from '../config';
import * as types from '../constants/ActionTypes';
import { handleUnauthorizedError } from '../lib/heartBeat';

export function getSubjects(books, authors, isHomework = false) {
    return async dispatch => {
        dispatch({
            type: types.GET_SUBJECTS,
            isHomework: isHomework
        });
        const url = `${API_URL}/taxonomies/subjects/cv`;
        let params = `origin=${applications.CREA_VERIFICHE}`;

        if (books) {
            let sBooks = JSON.stringify(books);
            params = `${params}&books=${sBooks}`;
        }
        if (authors) {
            let sAuthors = JSON.stringify(authors);
            params = `${params}&authors=${sAuthors}`;
        }

        let urlToInvoke = `${url}?${params}`;
        try {
            const { data } = await axios.get(`${urlToInvoke}`, {
                withCredentials: true
            });
            dispatch({
                type: types.GET_SUBJECTS_SUCCESS,
                result: data,
                isHomework: isHomework
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: types.GET_SUBJECTS_FAILURE,
                error: e,
                isHomework: isHomework
            });
        }
    };
}

export function getBooks(subjects, authors, isHomework = false) {
    return async dispatch => {
        dispatch({
            type: types.GET_BOOKS,
            isHomework: isHomework
        });

        let params = `origin=${applications.CREA_VERIFICHE}`;
        if (subjects) {
            let sSubjects = JSON.stringify(subjects);
            params = `${params}&subjects=${sSubjects}`;
        }
        if (authors) {
            let sAuthors = JSON.stringify(authors);
            params = `${params}&authors=${sAuthors}`;
        }
        const url = `${API_URL}/taxonomies/books/cv`;
        let urlToInvoke = `${url}?${params}`;

        try {
            const { data } = await axios.get(`${urlToInvoke}`, {
                withCredentials: true
            });
            dispatch({
                type: types.GET_BOOKS_SUCCESS,
                result: data,
                isHomework: isHomework
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: types.GET_BOOKS_FAILURE,
                error: e,
                isHomework: isHomework
            });
        }
    };
}

export function getAuthors(subjects, books, isHomework = false) {
    return async dispatch => {
        dispatch({
            type: types.GET_AUTHORS,
            isHomework: isHomework
        });

        let params = '';
        if (subjects) {
            let sSubjects = JSON.stringify(subjects);
            if (params === '') {
                params = `subjects=${sSubjects}`;
            } else {
                params = `${params}&subjects=${sSubjects}`;
            }
        }
        if (books) {
            let sBooks = JSON.stringify(books);
            if (params === '') {
                params = `books=${sBooks}`;
            } else {
                params = `${params}&books=${sBooks}`;
            }
        }
        const url = `${API_URL}/taxonomies/authors/cv`;
        let urlToInvoke = '';
        if (params === '') {
            urlToInvoke = url;
        } else {
            urlToInvoke = `${url}?${params}`;
        }
        try {
            const { data } = await axios.get(`${urlToInvoke}`, {
                withCredentials: true
            });
            dispatch({
                type: types.GET_AUTHORS_SUCCESS,
                result: data,
                isHomework: isHomework
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: types.GET_AUTHORS_FAILURE,
                error: e,
                isHomework: isHomework
            });
        }
    };
}

export function getItemTypes(subjects, books, authors) {
    const url = `${API_URL}/taxonomies/itemTypes/cv`;
    let params = `includeTheories=0&origin=${applications.CREA_VERIFICHE}`;

    if (authors && authors.length > 0) {
        let sAuthors = JSON.stringify(parserUtils.getElementsFromArrayByProp('id', authors));
        params = `${params}&authors=${sAuthors}`;
    }
    if (books && books.length > 0) {
        let sBooks = JSON.stringify(parserUtils.getElementsFromArrayByProp('ids', books));
        params = `${params}&books=${sBooks}`;
    }
    if (subjects && subjects.length > 0) {
        let sSubjects = JSON.stringify(parserUtils.getElementsFromArrayByProp('ids', subjects));
        params = `${params}&subjects=${sSubjects}`;
    }
    let urlToInvoke = '';
    if (params === '') {
        urlToInvoke = url;
    } else {
        urlToInvoke = `${url}?${params}`;
    }
    return {
        types: [types.GET_ITEM_TYPES, types.GET_ITEM_TYPES_SUCCESS, types.GET_ITEM_TYPES_FAILURE],
        promise: axios.get(urlToInvoke, {
            withCredentials: true
        })
    };
}

export function showFilters() {
    return {
        type: types.SHOW_FILTERS
    };
}

export function getTaxonomy(subjects, books, authors, isHomework = false) {
    const url = `${API_URL}/taxonomies/contents/cv`;

    let params = `origin=${applications.CREA_VERIFICHE}`;

    if (authors && authors.length > 0) {
        let sAuthors = JSON.stringify(parserUtils.getElementsFromArrayByProp('id', authors));
        params = `${params}&authors=${sAuthors}`;
    }

    if (books && books.length > 0) {
        let sBooks = JSON.stringify(parserUtils.getElementsFromArrayByProp('ids', books));
        params = `${params}&books=${sBooks}`;
    }

    if (subjects && subjects.length > 0) {
        let sSubjects = JSON.stringify(parserUtils.getElementsFromArrayByProp('ids', subjects));
        params = `${params}&subjects=${sSubjects}`;
    }

    return async dispatch => {
        dispatch({
            type: isHomework ? types.GET_HOMEWORK_CONTENT_TAXONOMY : types.GET_CONTENT_TAXONOMY
        });
        try {
            const { data } = await axios.get(`${url}?${params}&etag=${Math.random() * 1000}`, { withCredentials: true });
            dispatch({
                type: isHomework ? types.GET_HOMEWORK_CONTENT_TAXONOMY_SUCCESS : types.GET_CONTENT_TAXONOMY_SUCCESS,
                result: data
            });
        } catch (e) {
            dispatch({
                type: isHomework ? types.GET_HOMEWORK_CONTENT_TAXONOMY_FAILURE : types.GET_CONTENT_TAXONOMY_FAILURE,
                error: e
            });
        }
    };
}
